import React from 'react';
import { useAuth } from '../context/AuthContext';
import './ImpersonationBanner.css';

const ImpersonationBanner: React.FC = () => {
  const { impersonator, user, logout } = useAuth();
  if (!impersonator || !user) return null;

  return (
    <div className="impersonation-banner">
      <span>
        Viewing as <strong>{user.firstName} {user.lastName}</strong> ({user.email}) — read-only
      </span>
      <button onClick={logout}>Exit</button>
    </div>
  );
};

export default ImpersonationBanner;
